import {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {aboutCards} from "../../constants/data";
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SlideUp from "../ui/SlideUp";
gsap.registerPlugin(ScrollTrigger)

const AboutSection = () => {
  const productsRef = useRef();
  const innoRef = useRef();
  const {t} = useTranslation()
  // Get all translations in one call
  const visionData = {
    titles: t('vision.titles', { returnObjects: true }),
    descriptions: t('vision.descriptions', { returnObjects: true })
  };

  useEffect(() => {
    if (!productsRef.current) return;
    if (!innoRef.current) return;

    gsap.to(productsRef.current, {
      ease: "none",
      scrollTrigger: {
        trigger: productsRef.current,
        start: "top center",
        end: "bottom top",
        scrub: true,
      },
    })

    gsap.to(innoRef.current, {
      y: 550,
      ease: "none",
      scale: 0.85,
      background: "#0080FF",
      color: 'white',
      duration: 3,
      scrollTrigger: {
        trigger: innoRef.current,
        start: "top 30%",
        end: "bottom top",
        scrub: true,
      },
    });
  }, []);

  return (
    <div className="md:w-theme-container w-mobile-container mx-auto mt-40">
      <SlideUp>
        <div className="text-center text-2xl">{t('common.about')}</div>
      </SlideUp>

      {/* Main grid container */}
      <div className="grid md:grid-cols-2 grid-cols-1 mt-20 gap-8 md:gap-5 lg:gap-10">
        {/* Left column - single card */}
        <div className="flex flex-col h-full">
          <SlideUp>
            <div className="w-full overflow-hidden flex-x flex-col justify-between items-start text-black p-5 shadow-xl rounded-2xl border-l-4 border-theme-color h-72 bg-white">
              <div>
                <div className=" text-base text-theme-color md:text-xl my-2">Mesoft Business Solutions</div>
                <div className="text-xl md:text-2xl">{t('common.aboutUsTitle')} .</div>
              </div>
              <div className="md:text-md text-base mt-10 2xl:mt-14">
                {/*{t('common.aboutUsSectionDescription')}*/}
                {t('common.aboutUsDescription')}
              </div>
            </div>
          </SlideUp>
        </div>

        {/* Right column - 4 cards grid */}
        <SlideUp>
          <div className="grid md:grid-cols-2 md:gap-5 lg:gap-5 gap-5 h-full">
            {aboutCards.map((card, index) => (
              <div
                key={card.id}
                ref={card.id === 4 ? productsRef : null}
                className={`w-full bg-white text-black flex flex-col items-start justify-center p-5 shadow-2xl rounded-2xl
                ${card.borderPosition}-broke sm:border-l-4 border-theme-color h-full`}
              >
                <div className="md:text-3xl text-3xl">{t(`aboutCounterCards.countString.${index}`)}</div>
                <div className="text-base mt-2">{t(`aboutCounterCards.titles.${index}`)}</div>
              </div>
            ))}
          </div>
        </SlideUp>
      </div>

      {/* Vision section */}
      {/*<div className="grid md:grid-cols-3 grid-cols-1 gap-8 md:gap-5 lg:gap-10 mt-10">*/}
      {/*  {aboutVision.map((vision, index) => (*/}
      {/*    <SlideUp duration={(index+1) * 0.8} key={index}>*/}
      {/*      <div*/}
      {/*        ref={index===2 && window.innerWidth >= 700 ? innoRef : null}*/}
      {/*        className="bg-white shadow-2xl h-40 rounded-2xl border-r-4 border-theme-color"*/}
      {/*      >*/}
      {/*        <div className="p-5">*/}
      {/*          <div className="md:text-xl text-lg text-center my-2">{vision.title}</div>*/}
      {/*          <div className="text-center md:text-base text-sm ">{vision.description}</div>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </SlideUp>*/}
      {/*  ))}*/}
      {/*</div>*/}
      <div className="grid md:grid-cols-3 grid-cols-1 gap-8 md:gap-5 lg:gap-10 mt-10">
        {visionData.titles?.map((title, index) => (
          <SlideUp duration={(index + 1) * 0.8} key={index}>
            <div
              // ref={index===2 && window.innerWidth >= 700 ? innoRef : null} // Apply ref only to the third card on larger screens
              className="bg-white shadow-2xl h-40 lg:h-40 md:h-44 rounded-2xl border-r-4 border-theme-color"
            >
              <div className="p-5">
                <h3 className="md:text-xl text-lg text-center my-2">
                  {title}
                </h3>
                <p className="text-center md:text-base text-sm">
                  {visionData.descriptions[index]}
                </p>
              </div>
            </div>
          </SlideUp>
        ))}
      </div>

    </div>
  );
};

export default AboutSection;
